// Rounding helpers, matched to the legacy program against 437K archived values.
//
// round(): plain binary floating point, half away from zero, NO epsilon. The legacy program computed
// in doubles, so an exact decimal tie such as 5.725 (stored as 5.72499999…) rounds down there too;
// nudging it up would disagree with ~2 % of archived spirometry predictions.
//
// floor(): keeps a tiny epsilon so products that are integers on paper (0.7 × 130 = 90.99999…) do not
// drop a whole unit.
const EPS = 1e-9;

export const floor = (x: number): number => Math.floor(x + EPS);

/** Round half away from zero to `dp` decimals, in binary floating point. */
export function round(x: number, dp = 0): number {
  const f = 10 ** dp;
  return (Math.sign(x) * Math.round(Math.abs(x) * f)) / f;
}

export const isNum = (x: unknown): x is number => typeof x === 'number' && Number.isFinite(x);
